/**
 * Body of the Keystone South UK invoice. Header and footer images come from
 * Admin → PDF Export, so this has no company block of its own.
 *
 * Seeded into document_templates (KSU, Invoice) by 20261014180000-ksu-invoice-template.sql
 * and editable in the template editor from then on. Also used when KSU has no saved template.
 *
 * Notes for editors:
 * - Styles are inline: the renderer strips curly braces, so a <style> block would break.
 * - {{#lineItems}}…{{/lineItems}} becomes generated rows with five cells (description, qty,
 *   unit, unit price, amount), so the table keeps five columns. Those cells are styled by
 *   ACCOUNT_INVOICE_EXPORT_CSS in the PDF wrapper.
 */
const LABEL = 'color: #6b7280; font-size: 8pt; text-transform: uppercase; letter-spacing: 0.05em;';
const META_LABEL = `${LABEL} padding: 2px 12px 2px 0;`;
const TH = 'font-size: 8pt; color: #6b7280; text-transform: uppercase; border-bottom: 1px solid #d1d5db; padding: 6px 4px;';
const NUM = 'text-align: right; white-space: nowrap;';
const TOTAL_ROW = 'font-weight: bold; border-top: 1px solid #1f2933; padding: 6px 4px 4px;';

export const KSU_INVOICE_TEMPLATE = `<div class="ksu-invoice" style="font-size: 10.5pt; color: #1f2933;">
<h1 style="font-size: 20pt; letter-spacing: 0.04em; margin: 0 0 14px;">INVOICE</h1>
<table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
<tbody>
<tr>
<td style="vertical-align: top; width: 55%;">
<div style="${LABEL} margin-bottom: 4px;">Bill to</div>
<strong>{{customerName}}</strong><br />
{{#customerAddress}}{{customerAddress}}{{/customerAddress}}
</td>
<td style="vertical-align: top;">
<table style="border-collapse: collapse;">
<tbody>
<tr><td style="${META_LABEL}">Invoice no.</td><td><strong>{{documentRef}}</strong></td></tr>
<tr><td style="${META_LABEL}">Date</td><td>{{documentDate}}</td></tr>
<tr><td style="${META_LABEL}">Due</td><td>{{dueDate}} ({{paymentTermsLabel}})</td></tr>
<tr><td style="${META_LABEL}">Reference</td><td>{{arrangementRef}} · {{worksSummary}}</td></tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
<table class="ksu-lines" style="width: 100%; border-collapse: collapse; margin-top: 8px;">
<thead>
<tr>
<th style="${TH} text-align: left;">Description</th>
<th style="${TH} ${NUM}">Qty</th>
<th style="${TH} ${NUM}">Unit</th>
<th style="${TH} ${NUM}">Unit price</th>
<th style="${TH} ${NUM}">Amount (ex VAT)</th>
</tr>
</thead>
<tbody>
{{#lineItems}}{{/lineItems}}
</tbody>
</table>
<table style="margin-left: auto; margin-top: 12px; border-collapse: collapse; min-width: 260px;">
<tbody>
<tr><td style="padding: 4px;">Net</td><td style="padding: 4px; ${NUM}">{{totalExVat}}</td></tr>
{{#vatEnabled}}<tr><td style="padding: 4px;">VAT ({{vatPct}}%)</td><td style="padding: 4px; ${NUM}">{{vatAmount}}</td></tr>{{/vatEnabled}}
{{#noVat}}<tr><td style="padding: 4px;">VAT</td><td style="padding: 4px; ${NUM}">Not charged</td></tr>{{/noVat}}
<tr><td style="${TOTAL_ROW}">Total</td><td style="${TOTAL_ROW} ${NUM}">{{grandTotal}}</td></tr>
{{#hasCisDeduction}}<tr><td style="padding: 4px;">Less CIS deduction on labour of {{cisLabourAmount}}</td><td style="padding: 4px; ${NUM}">&minus; {{cisDeductionAmount}}</td></tr>
<tr><td style="${TOTAL_ROW}">Amount payable</td><td style="${TOTAL_ROW} ${NUM}">{{amountOutstanding}}</td></tr>{{/hasCisDeduction}}
</tbody>
</table>
{{#description}}<div style="margin-top: 22px; font-size: 9.5pt; line-height: 1.5;">{{description}}</div>{{/description}}
{{#bankName}}<div style="margin-top: 16px; font-size: 9.5pt; line-height: 1.5;">
<div style="${LABEL} margin-bottom: 2px;">Payment details</div>
Bank: {{bankName}}<br />
{{#bankAccountName}}Account name: {{bankAccountName}}<br />{{/bankAccountName}}
{{#bankSortCode}}Sort code: {{bankSortCode}}<br />{{/bankSortCode}}
{{#bankAccountNumber}}Account number: {{bankAccountNumber}}{{/bankAccountNumber}}
</div>{{/bankName}}
</div>`;

/** Styles for the generated line rows, added to the PDF page around the template. */
export const ACCOUNT_INVOICE_EXPORT_CSS = `
  table.ksu-lines td { border-bottom: 1px solid #eef0f2; padding: 8px 4px; vertical-align: top; }
  table.ksu-lines td:nth-child(n+2) { text-align: right; white-space: nowrap; }
  table.ksu-lines .item-description { color: #6b7280; font-size: 9pt; }
`;
